import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import parseGGDriver from "../../helpers/parseGGDriver"
import {parse} from "json2csv"
import {saveAs} from "file-saver"

class ExportArx4 extends Component {
    _parseARX4 = (items) => {
        const results = []

        for (const item of items) {
            const {barcodeNumber, products} = item

            for (const i in products) {
                const product = products[i]
                const {color, size, designFront, designBack} = product

                if (designFront) {
                    results.push({
                        color,
                        size,
                        name: `${barcodeNumber}_${parseInt(i) + 1}_F`,
                        design: parseGGDriver(designFront)
                    })
                }
                if (designBack) {
                    results.push({
                        color,
                        size,
                        name: `${barcodeNumber}_${parseInt(i) + 1}_B`,
                        design: parseGGDriver(designBack)
                    })
                }
            }
        }

        return results
    }

    _handleClickARX4 = () => {
        const {items} = this.props
        const arx4 = this._parseARX4(items)
        const fields = ['name', 'color', 'size', 'design']
        const opts = {fields}

        try {
            const csv = parse(arx4, opts)
            const file = new File([csv], 'arx4.csv', {type: 'application/csv; charset=UTF-8'})
            saveAs(file)
        } catch (err) {
            alert(err.message)
        }
    }

    render() {
        return (
            <Button className="btn btn-light btn-labeled btn-labeled-left ml-1" onClick={this._handleClickARX4}>
                <b><i className="icon-printer2"/></b>
                Tải ARX4
            </Button>
        )
    }
}

ExportArx4.propTypes = {
    items: PropTypes.array.isRequired
}

export default ExportArx4
